import { render, staticRenderFns } from "./ThermalCameraControllerTemplate.vue?vue&type=template&id=a064e596&scoped=true&"
import script from "./ThermalCameraControllerTemplate.vue?vue&type=script&lang=js&"
export * from "./ThermalCameraControllerTemplate.vue?vue&type=script&lang=js&"
import style0 from "./ThermalCameraControllerTemplate.vue?vue&type=style&index=0&id=a064e596&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a064e596",
  null
  
)

export default component.exports